document.addEventListener('DOMContentLoaded', function () {
    var ul = document.querySelector('.our-directions ul');
    var liWidth = ul.querySelector('li').offsetWidth;
    var scrollAmount = 0;
    var isAnimating = false;
    var animationFrame;

    document.querySelector('.next-arrow__bottom').addEventListener('click', function () {
        scrollAmount += liWidth;
        var maxScroll = ul.scrollWidth - ul.offsetWidth;

        if (scrollAmount > maxScroll) {
            scrollAmount = 0;
        }

        animateScroll();
    });

    document.querySelector('.prew-arrow__bottom').addEventListener('click', function () {
        scrollAmount -= liWidth;
        var maxScroll = ul.scrollWidth - ul.offsetWidth;

        if (scrollAmount < 0) {
            scrollAmount = maxScroll;
        }

        animateScroll();
    });

    ul.addEventListener('scroll', function () {
        if (!isAnimating) {
            cancelAnimationFrame(animationFrame);
        }
    });

    function animateScroll() {
        var start = ul.scrollLeft;
        var end = scrollAmount;
        var change = end - start;
        var startTime = performance.now();
        var duration = 500;

        function updateScroll(timestamp) {
            var currentTime = timestamp - startTime;
            ul.scrollLeft = easeInOutQuad(currentTime, start, change, duration);

            if (currentTime < duration) {
                isAnimating = true;
                animationFrame = requestAnimationFrame(updateScroll);
            } else {
                isAnimating = false;
            }
        }

        function easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(updateScroll);
    }
});
